import { createReducer } from '@reduxjs/toolkit';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { type PaymentState } from '../types/StoreState';
import { createPayPalOrderAction } from '../actions/payment/createPayPalOrder';
import { updatePayPalOrderAction } from '../actions/payment/updatePayPalOrder';
import { startApplePayFlow } from '../actions/payment/startApplePayFlow';
import { addAsyncStatusCases } from '../utils/redux/addAsyncStatusCases';

const initialState: PaymentState = {
  [PaymentMethod.PayPal]: {
    orderId: null,
    chargeId: null,
    cashierOrderId: null,
    shippingContact: null,
    shippingMethods: null,
    paymentAmount: '',
    paymentBreakdown: null,
    orderItems: [],
  },
  [PaymentMethod.ApplePay]: {
    initSession: 'idle',
  },
};

export const paymentStateReducer = createReducer(initialState, (builder) => {
  builder.addCase(createPayPalOrderAction, (state, action) => {
    state.payPal = { ...state.payPal, ...action.payload };
  });
  builder.addCase(updatePayPalOrderAction, (state, action) => {
    const { shippingContact, paymentAmount, paymentBreakdown, shippingMethods } = action.payload;
    state.payPal.paymentAmount = paymentAmount;
    state.payPal.paymentBreakdown = paymentBreakdown;
    state.payPal.shippingContact = shippingContact;
    state.payPal.shippingMethods = shippingMethods;
  });

  addAsyncStatusCases(builder, startApplePayFlow, (state, status) => {
    state.applePay.initSession = status;
  });
});
